<template>
    <div>
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">抵押物性质</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div id="echart05" class="chart05" :style="{height: '280px'}"></div>
    </div>
</template>

<script>

    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorEchartsFive',
        data() {
            return {
                nowDate: "",
                financingByPropertyUsage: []
            }
        },
        computed: {

        },
        mounted() {
            this.getFinancingByPropertyUsageList();
        },
        methods:{
            echart05(){
                let myChart = this.$echarts.init(document.getElementById('echart05'))
                myChart.setOption({
                    // color: ['#3f8cf8','#11baa8','#e8d745','#e88c45'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        right: '15%',
                        top: '22%',
                        data: this.financingByPropertyUsage.map(item=>item.fi__propertyUsage),
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        },
                    },
                    series: [
                        {
                            name: '抵押物性质',
                            type: 'pie',
                            radius: '55%',
                            center: ['35%', '50%'],
                            data: this.financingByPropertyUsage.map(item=>({
                                name: item.fi__propertyUsage,
                                value: item.fi__counts||0
                            })),
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            itemStyle:{
                                normal:{
                                    label:{
                                        textStyle:{
                                            fontSize:24,
                                            color:'#96dcff'
                                        }
                                    },
                                    labelLine:{
                                        lineStyle:{
                                            color:'#96dcff'
                                        }
                                    }
                                }

                            }
                        }
                    ]
                });
            },
            getFinancingByPropertyUsageList: function () {
                xhr.getFinancingByPropertyUsageList(0, ({data}) => {
                    if (data.status === 'success') {
                        this.financingByPropertyUsage = (data.data || []).filter(item=>item.fi__propertyUsage)
                        this.echart05()
                    }
                })
            }
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorEchartsFive.vue